
import React, { useState, useEffect } from 'react';
import { DashboardMetrics } from './DashboardMetrics';
import { PeriodSelector } from './PeriodSelector';
import { ViewPeriod, Metrics } from '@/types/dashboard';
import { DashboardService } from '@/services/DashboardService';
import { toast } from 'sonner';

interface DashboardOverviewProps {
  psychologistId?: string;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({ psychologistId }) => {
  const [period, setPeriod] = useState<ViewPeriod>('week');
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!psychologistId) {
      setLoading(false);
      return;
    }

    const loadMetrics = async () => {
      try {
        setLoading(true);
        const data = await DashboardService.fetchMetrics(psychologistId, period);
        setMetrics(data);
      } catch (error) {
        console.error('Error loading metrics:', error);
        toast.error('Erro ao carregar métricas');
      } finally {
        setLoading(false);
      }
    };

    loadMetrics();
  }, [psychologistId, period]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Visão Geral</h2>
        <PeriodSelector value={period} onChange={setPeriod} />
      </div>
      
      <DashboardMetrics 
        metrics={metrics}
        period={period}
        loading={loading}
      />
    </div>
  );
};

export default DashboardOverview;
